import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: start;
  border-radius: 6px;
  background-color: ${(props) => props.theme.background};
  margin: 15px 0 0;
`;

export default Container;
